import {EventTypeOption, EventVenue} from 'api/events/events.types';
import {EventFilterOption} from './event-management.types';

const MAX_VENUE_LABEL_LENGTH = 19;

const LOCATION = {
    US: {distanceVar: 'distanceMiles', unit: 'mi'},
    CA: {distanceVar: 'distanceKilometers', unit: 'km'},
} as const;

const DEFAULT_LOCATION = 'US';

type LocationKey = keyof typeof LOCATION;

const formatLabel = (label: string, distance: string) => {
    let newLabel = label;

    if (label.length > MAX_VENUE_LABEL_LENGTH) {
        newLabel = `${label.slice(0, MAX_VENUE_LABEL_LENGTH)}...`;
    }

    if (distance) {
        newLabel = `${newLabel} (${distance})`;
    }

    return newLabel;
};

export const formatEventVenueFilterOptions = (
    data: EventVenue[],
    location: LocationKey = DEFAULT_LOCATION
): EventFilterOption[] => {
    const locationConfig = LOCATION[location] || LOCATION[DEFAULT_LOCATION];
    const {distanceVar, unit} = locationConfig;

    const formattedData = data.map((item) => {
        const distanceValue = item[distanceVar];
        const distance = distanceValue ? `${distanceValue} ${unit}` : '';

        return {
            label: formatLabel(item.title, distance),
            value: item.title,
            id: item.id ? item.id.toString() : '',
        };
    });

    return formattedData;
};

const formatEventFilterOptions = (
    data: (EventTypeOption | EventVenue)[]
): EventFilterOption[] => {
    const formattedData = data.map((item) => ({
        label: item.title,
        value: item.title,
        id: item.id ? item.id.toString() : '',
    }));

    return formattedData;
};

export default formatEventFilterOptions;
